import React from 'react';
import classNames from 'classnames';
import { IconPlayerPlay, IconPlayerPause } from '@tabler/icons-react';
import s from './custom-video-player.module.scss';

// ВАЖНО: состояние иконки (play/pause) передаём пропом, а НЕ меняем тип
// компонента. Смена типа (IconPlayerPlay -> IconPlayerPause) посреди нативного drag
// размонтирует SVG, и Chrome отменяет drag — ползунок откатывается к значению
// начала drag. Обе иконки смонтированы постоянно, переключение — через CSS-видимость.
export const PlayPauseIndicator = ({ size, isPlaying }) => (
	<span className={s.volumeIconSet} style={{ width: size, height: size }} aria-hidden="true">
		<IconPlayerPlay size={size} className={classNames(s.volumeIcon, isPlaying && s.volumeIconHidden)} />
		<IconPlayerPause size={size} className={classNames(s.volumeIcon, !isPlaying && s.volumeIconHidden)} />
	</span>
);
